module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-06-03 at 19.22.47.90f74046.jpeg";